import Dashboard from 'src/wrapper/dashboard/seller';
import Account from 'src/wrapper/account';
import StudentDetail from 'src/wrapper/sellers/student-detail';

export const sellerRoutes = (paths) => {
  return [
    { path: paths.dashboard.index, component: Dashboard },
    { path: paths.dashboard.account, component: Account },
    { path: paths.students.details, component: StudentDetail },
  ];
};
